import { render } from "./NetscapeHeader.vue?vue&type=template&id=5846492f&scoped=true"
import script from "./NetscapeHeader.vue?vue&type=script&lang=js"
export * from "./NetscapeHeader.vue?vue&type=script&lang=js"

import "./NetscapeHeader.vue?vue&type=style&index=0&id=5846492f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5846492f"]])

export default __exports__